import React from 'react';
import {
  View,
  Text,
  Image,
  StyleSheet,
  ActivityIndicator,
  Modal,
} from 'react-native';
import {Images} from '../../constants/Images';
import { Colors } from '../../constants/Colors';

interface ILoadingScreen {
  visible?: boolean;
}

const LoadingScreen = ({visible}: ILoadingScreen) => {
  return (
    <Modal animationType="fade" transparent={true} visible={visible}>
      <View style={styles.container}>
        {/* Garrafa no centro */}
        <Image source={Images.bottleLoading} style={styles.bottle} />

        {/* Texto "Carregando" */}
        <Text style={styles.loadingText}>Carregando</Text>

        {/* Bolhas ou indicador de atividade */}
        <ActivityIndicator
          size="small"
          color={Colors.RedPallete.red}
          style={styles.bubbles}
        />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
  },
  bottle: {
    marginBottom: 20,
  },
  loadingText: {
    fontSize: 18,
    fontFamily: 'TCCC-UnityText Bold',
    color: '#e60000', // Cor vermelha para o texto
    marginVertical: 50,
  },
  bubbles: {
    marginTop: 20,
  },
});

export default LoadingScreen;
